// utils/api.js
import axios from "axios";
import toast from "react-hot-toast";

import { getAllocatedGuests } from "../server/Api"; // adjust import path

export const fetchAllocations = async (eventId) => {
  if (!eventId) return { formatted: {}, regNoMap: {} };

  try {
    const res = await axios.get(getAllocatedGuests(eventId));
    const allocations = res.data.data;

    const formatted = {};
    const regNoMap = {};

    allocations.forEach((entry) => {
      const key = `${entry.guestId}-${entry.attendeeId || "null"}`;
      formatted[key] = (entry.allocatedOccasionIds || []).map((id) =>
        String(id)
      );

      if (entry.regNo) {
        regNoMap[key] = entry.regNo;
      }
    });

    return { formatted, regNoMap };
  } catch (error) {
    console.error("Failed to fetch allocations:", error);
    toast.error("Failed to load guest allocations.");
    return { formatted: {}, regNoMap: {} };
  }
};
